import { Apartment } from '../types/apartment';

export const APARTMENTS: Apartment[] = [
  { id: '1', image: '/assets/images/city-people/apart_1.png', title: 'פומבדיתא 20-22' },
  { id: '2', image: '/assets/images/city-people/apart_2.png', title: 'דוד המלך 29' },
  { id: '3', image: '/assets/images/city-people/apart_3.png', title: 'פומבדיתא 20-22' },
  { id: '4', image: '/assets/images/city-people/apart_4.png', title: 'דוד המלך 29' },
];
